import React, { useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const CheckoutForm = ({ book }) => {
  // State for the form fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false); // Updated loading state
  const [error, setError] = useState(null); // State for error message
  const [data,setData]=useState("")
   const [file, setFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
     const token = localStorage.getItem("userToken");

    if(!firstName || !lastName){
      setError("Please Fill Name.");
      return false
    }

      if(!phoneNumber){
      setError("Please Fill PhoneNumber.");
      return false
     
    }

      if(!address){
      setError("Please Fill Address.");
      return false
    }
       if(!file){
      setError("Please Fill Payment ScreenShot file.");
      return false
    }
     setLoading(true);

     const formData = new FormData();
     formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("phoneNumber", phoneNumber);
      formData.append("address", address);
      formData.append("payment", file);

    try {
     const response = await axios.post(
        `${SERVER_URL}/book/purchase_book/${book._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': token,
          },
        }
      );

      const order = response.data?.data;
     setData(order)
     setFirstName("")
     setLastName("")
     setAddress("")
     setPhoneNumber("")
     setFile("")

    } catch (err) {
      console.error(err);
      setError("An error occurred while processing your order."); // Set error state
    } finally {
      setLoading(false); // Hide the loading spinner
    }
  };

    const handleFileChange= (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && !selectedFile.type.startsWith('image/')) {
      alert('Please upload a valid image file.');
      return;
    }

    if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
      alert('File size exceeds 5MB limit.');
      return;
    }

    setFile(selectedFile);
  };

  return (
    <div className="react-course-filter back__course__page_grid pb---40 pt---110">
      <div className="container pb---70">
        <form className="d-flex flex-column gap-4 full-width-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="form-group mb-4 col-lg-6 col-12">
              <label className="mb-1" htmlFor="first_name">
                First Name
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                id="first_name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group mb-4 col-lg-6 col-12">
              <label className="mb-1" htmlFor="last_name">
                Last Name
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                id="last_name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group mb-4">
            <label className="mb-1" htmlFor="phone_number">
              Phone Number
            </label>
            <input
              type="tel"
              className="form-control form-control-lg"
              id="phone_number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label className="mb-1" htmlFor="book">
              ဝယ်ယူမည့်စာအုပ်
            </label>
            <input
              type="text"
              className="form-control form-control-lg"
              id="book"
              value={book?.title}
              readOnly
            />
          </div>

          <div className="form-group mb-4">
            <label className="mb-1" htmlFor="address">
              Address
            </label>
            <textarea
              className="form-control form-control-lg"
              id="address"
              rows={3}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            ></textarea>
          </div>
           <div className="input-container mb-4">
          <label className="input-label" htmlFor="snapShot">
            Upload Payment Screenshot: <span className="require-star">*</span>
          </label>
          <input
            type="file"
            className="form-control"
            id="snapShot"
            accept="image/*"
            onChange={handleFileChange}
            required
          />
        </div>

          
          {error && <div className="alert alert-danger">{error}</div>}
          {data &&  <div className="alert alert-info">{data}</div>}

          <button type="submit" className="btn btn-primary btn-lg px-4" disabled={loading}>
            {loading ? "Processing..." : "Buy Now"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CheckoutForm;
